import { render, staticRenderFns } from "./SkillsComponent.vue?vue&type=template&id=7fc42229&"
import script from "./SkillsComponent.vue?vue&type=script&lang=js&"
export * from "./SkillsComponent.vue?vue&type=script&lang=js&"
import style0 from "./SkillsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports